module.exports = __webpack_public_path__ + "img/banner2.feac431f.jpg";